/* unplugin-vue-components disabled */import { render } from "./ShopDetailView.vue?vue&type=template&id=23ead406&scoped=true"
import script from "./ShopDetailView.vue?vue&type=script&lang=js"
export * from "./ShopDetailView.vue?vue&type=script&lang=js"

import "./ShopDetailView.vue?vue&type=style&index=0&id=23ead406&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ead406"]])

export default __exports__